import { useContext } from "react";
import FeatureFlagContext from "../../Context/FeatureFlag/FeatureFlagContext";

function useFeatureFlags() {
    const featureFlags = useContext(FeatureFlagContext);

    const environment = process.env.REACT_APP_INSTANCE;

    return featureFlags[environment];
}

export default useFeatureFlags;